import { FolderTree } from "lucide-react";

export default function AssetLiteStrategyContentsCard() {
  return (
    <div className="relative flex-shrink-0 w-[450px] flex flex-col border-2 border-black bg-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
      {/* Card Header */}
      <div className="p-4 border-b-2 border-black bg-orange-50">
        <div className="flex items-start gap-3">
          {/* Icon */}
          <div className="flex-shrink-0">
            <FolderTree className="w-8 h-8 text-black" />
          </div>

          {/* Title */}
          <div className="flex-1 min-w-0">
            <div className="inline-block px-2 py-0.5 text-xs font-bold rounded bg-black text-white uppercase tracking-wide mb-2">
              Contents
            </div>
            <h3 className="text-base sm:text-lg font-black text-black uppercase tracking-wide">
              Thread Structure
            </h3>
          </div>
        </div>
      </div>

      {/* Card Content - Scrollable */}
      <div className="flex-1 overflow-y-auto p-4 min-h-[200px] max-h-[280px]">
        <div className="font-mono text-sm space-y-1">
          {/* Root */}
          <div className="text-base font-bold text-blue-600 mb-2">
            Honey House
          </div>

          {/* Connector */}
          <div className="text-gray-400">│</div>

          {/* Strategy Level */}
          <div className="flex">
            <span className="text-gray-400 mr-2">└──</span>
            <span className="font-bold text-purple-600">
              Asset-lite Strategy
            </span>
          </div>

          {/* Placeholder notice */}
          <div className="ml-6 text-xs text-gray-500 italic mt-3">
            Projects that don't require large CAPEX investments with short
            payback
          </div>
          {/* Connector */}
          <div className="text-gray-400">│</div>

          {/* Phase 1 */}
          <div className="flex">
            <span className="text-gray-400 mr-2">└──</span>
            <span className="font-bold text-black">
              Phase 1 - Franchise Roll Out
            </span>
          </div>
          <div className="ml-6 text-xs text-gray-600 mt-1">
            Targeting launch of chapters with the potential to be on every
            highstreet
          </div>
          {/* Connector */}
          <div className="text-gray-400">│</div>

          {/* Phase 2 */}
          <div className="flex">
            <span className="text-gray-400 mr-2">└──</span>
            <span className="font-bold text-black">Phase 2 - Festivals</span>
          </div>
          <div className="ml-6 text-xs text-gray-600 mt-1">Coming Soon</div>
          {/* Connector */}
          <div className="text-gray-400">│</div>

          {/* Phase 3 */}
          <div className="flex">
            <span className="text-gray-400 mr-2">└──</span>
            <span className="font-bold text-black">
              Phase 3 - Hotel Partnerships Travel Packages
            </span>
          </div>
          <div className="ml-6 text-xs text-gray-600 mt-1">Coming Soon</div>
        </div>
      </div>

      {/* Card Footer */}
      <div className="p-4 border-t-2 border-black bg-gray-50">
        <div className="text-xs text-gray-600 italic text-center">
          Swipe to explore each project →
        </div>
      </div>
    </div>
  );
}
